<div class="header-wrapper">
  <div class="row m-0">
    <div class="col-6 p-0">
      <div class="header-logo">
        <img
          src="images/valamar-logo.svg"
          alt="valamar-logo"
          (click)="onHome()"
          class="pointer"
        />
      </div>
    </div>

    <div class="col-6 p-0">
      <div class="header-menu">
        <div class="menu-item language">
          <form [formGroup]="languageForm">
            <mat-form-field appearance="fill" class="language-input">
              <mat-select formControlName="language">
                <mat-option [value]="language.HR">
                  {{ language.HR | uppercase }}
                </mat-option>
                <mat-option [value]="language.EN">
                  {{ language.EN | uppercase }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
        <div class="menu-item cart">
          <mat-icon
            aria-hidden="false"
            (click)="onOpenShoppingCart()"
            [matBadge]="cartItemsCount()"
            matBadgeSize="large"
            >shopping_cart</mat-icon
          >
        </div>
      </div>
    </div>
  </div>
</div>
